/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MoneyOutput } from './MoneyOutput';
import {
    MoneyOutputFromJSON,
    MoneyOutputFromJSONTyped,
    MoneyOutputToJSON,
    MoneyOutputToJSONTyped,
} from './MoneyOutput';

/**
 * 
 * @export
 * @interface MarketingTrendRowData
 */
export interface MarketingTrendRowData {
    /**
     * 
     * @type {string}
     * @memberof MarketingTrendRowData
     */
    date?: string;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MarketingTrendRowData
     */
    spend?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MarketingTrendRowData
     */
    turnover?: MoneyOutput;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MarketingTrendRowData
     */
    goodsMargin?: MoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    orders?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    clicks?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    impressions?: number;
    /**
     * 
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    pno?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    poas?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    ctr?: number | null;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MarketingTrendRowData
     */
    cpc?: MoneyOutput | null;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MarketingTrendRowData
     */
    cpm?: MoneyOutput | null;
    /**
     * 
     * @type {MoneyOutput}
     * @memberof MarketingTrendRowData
     */
    costPerOrder?: MoneyOutput | null;
    /**
     * 
     * @type {number}
     * @memberof MarketingTrendRowData
     */
    conversionRate?: number | null;
}

/**
 * Check if a given object implements the MarketingTrendRowData interface.
 */
export function instanceOfMarketingTrendRowData(value: object): value is MarketingTrendRowData {
    return true;
}

export function MarketingTrendRowDataFromJSON(json: any): MarketingTrendRowData {
    return MarketingTrendRowDataFromJSONTyped(json, false);
}

export function MarketingTrendRowDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): MarketingTrendRowData {
    if (json == null) {
        return json;
    }
    return {
        
        'date': json['date'] == null ? undefined : json['date'],
        'spend': json['spend'] == null ? undefined : MoneyOutputFromJSON(json['spend']),
        'turnover': json['turnover'] == null ? undefined : MoneyOutputFromJSON(json['turnover']),
        'goodsMargin': json['goodsMargin'] === undefined ? undefined : json['goodsMargin'] === null ? null : MoneyOutputFromJSON(json['goodsMargin']),
        'orders': json['orders'] == null ? undefined : json['orders'],
        'clicks': json['clicks'] == null ? undefined : json['clicks'],
        'impressions': json['impressions'] == null ? undefined : json['impressions'],
        'pno': json['pno'] === undefined ? undefined : json['pno'] === null ? null : json['pno'],
        'poas': json['poas'] === undefined ? undefined : json['poas'] === null ? null : json['poas'],
        'ctr': json['ctr'] === undefined ? undefined : json['ctr'] === null ? null : json['ctr'],
        'cpc': json['cpc'] === undefined ? undefined : json['cpc'] === null ? null : MoneyOutputFromJSON(json['cpc']),
        'cpm': json['cpm'] === undefined ? undefined : json['cpm'] === null ? null : MoneyOutputFromJSON(json['cpm']),
        'costPerOrder': json['costPerOrder'] === undefined ? undefined : json['costPerOrder'] === null ? null : MoneyOutputFromJSON(json['costPerOrder']),
        'conversionRate': json['conversionRate'] === undefined ? undefined : json['conversionRate'] === null ? null : json['conversionRate'],
    };
}

export function MarketingTrendRowDataToJSON(json: any): MarketingTrendRowData {
    return MarketingTrendRowDataToJSONTyped(json, false);
}

export function MarketingTrendRowDataToJSONTyped(value?: MarketingTrendRowData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'date': value['date'],
        'spend': MoneyOutputToJSON(value['spend']),
        'turnover': MoneyOutputToJSON(value['turnover']),
        'goodsMargin': MoneyOutputToJSON(value['goodsMargin']),
        'orders': value['orders'],
        'clicks': value['clicks'],
        'impressions': value['impressions'],
        'pno': value['pno'],
        'poas': value['poas'],
        'ctr': value['ctr'],
        'cpc': MoneyOutputToJSON(value['cpc']),
        'cpm': MoneyOutputToJSON(value['cpm']),
        'costPerOrder': MoneyOutputToJSON(value['costPerOrder']),
        'conversionRate': value['conversionRate'],
    };
}

